import React, { Component } from 'react'
import PropTypes from 'prop-types'
import style from './CheckboxFilter.less'

class CheckboxFilterOption extends Component {

  getLabel = () => {
    const {
      item, showLength,
    } = this.props
    const needLength = (showLength) ? `( ${item.data.length} )` : ''
    return (
      <>{item.label} {needLength}</>
    )
  }

  clickHandler = (e) => {
    e.preventDefault()
    e.nativeEvent.stopImmediatePropagation()
    this.props.onChange(this.props.index)
  }

  render() {
    const {
      item, index, checked,
    } = this.props
    const isActive = (checked) ? style.active : {}
    const hasItems = (item.data.length == 0) ? style.disabled : {}

    return (
      <a
        href="#"
        key={index}
        className={`${style.filterOption} ${isActive} ${hasItems}`}
        onClick={this.clickHandler}
        data-test={item.type}
      >
        <span>{this.getLabel()}</span>
      </a>
    )
  }
}

CheckboxFilterOption.defaultProps = {
  showLength: true,
}

CheckboxFilterOption.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  showLength: PropTypes.bool,
}

export default CheckboxFilterOption
